import { createTheme } from '@mui/material';
import type {} from '@mui/x-date-pickers/themeAugmentation';

import { palette } from './palette';
import { muiTableContainer } from './mui-table-container';
import { muiTableCell } from './mui-table-cell';
import { muiTableRow } from './mui-table-row';
import { muiIconButton } from './mui-icon-button';
import { muiCheckbox } from './mui-checkbox';
import { muiDivider } from './mui-divider';
import { muiSwitch } from './mui-switch';
import { muiDateCalendar } from './mui-date-calendar';
import { muiTab } from './mui-tab';
import { muiTabs } from './mui-tabs';
import { muiDialog } from './mui-dialog';
import { muiDialogTitle } from './mui-dialog-title';
import { muiDialogContent } from './mui-dialog-content';
import { muiDialogActions } from './mui-dialog-actions';

export type HorizonTheme = typeof horizonTheme;

declare module '@mui/material/styles' {
  interface Palette {
    blue: Palette['primary'];
    red: Palette['primary'];
    orange: Palette['primary'];
    green: Palette['primary'];
    yellow: Palette['primary'];
    black: Palette['primary'];
    white: Palette['primary'];
    blue100: Palette['primary'];
    blue400: Palette['primary'];
    blue500: Palette['primary'];
    blue800: Palette['primary'];
    blue900: Palette['primary'];
    gray100: Palette['primary'];
    gray200: Palette['primary'];
    gray300: Palette['primary'];
    gray500: Palette['primary'];
    gray800: Palette['primary'];
    yellow100: Palette['primary'];
    green100: Palette['primary'];
    green400: Palette['primary'];
    green900: Palette['primary'];
    orange100: Palette['primary'];
    red100: Palette['primary'];
    shadyblue100: Palette['primary'];
    shadyblue900: Palette['primary'];
    red300: Palette['primary'];
    red500: Palette['primary'];
    red900: Palette['primary'];
    green500: Palette['primary'];
    orange500: Palette['primary'];
    skyBlue100: Palette['primary'];
  }

  interface PaletteOptions {
    blue?: PaletteOptions['primary'];
    red?: PaletteOptions['primary'];
    orange?: PaletteOptions['primary'];
    green?: PaletteOptions['primary'];
    yellow?: PaletteOptions['primary'];
    black?: PaletteOptions['primary'];
    white?: PaletteOptions['primary'];
    blue100?: PaletteOptions['primary'];
    blue400?: PaletteOptions['primary'];
    blue500?: PaletteOptions['primary'];
    blue800?: PaletteOptions['primary'];
    blue900?: PaletteOptions['primary'];
    gray100?: PaletteOptions['primary'];
    gray200?: PaletteOptions['primary'];
    gray300?: PaletteOptions['primary'];
    gray500?: PaletteOptions['primary'];
    gray800?: PaletteOptions['primary'];
    yellow100?: PaletteOptions['primary'];
    green100?: PaletteOptions['primary'];
    green400?: PaletteOptions['primary'];
    green900?: PaletteOptions['primary'];
    orange100?: PaletteOptions['primary'];
    red100?: PaletteOptions['primary'];
    shadyblue100?: PaletteOptions['primary'];
    shadyblue900?: PaletteOptions['primary'];
    red300?: PaletteOptions['primary'];
    red500?: PaletteOptions['primary'];
    red900?: PaletteOptions['primary'];
    green500?: PaletteOptions['primary'];
    orange500?: PaletteOptions['primary'];
    skyBlue100?: PaletteOptions['primary'];
  }

  interface BreakpointOverrides {
    tablet: true;
    desktop: true;
  }
}

export const horizonTheme = createTheme({
  palette,
  components: {
    MuiDialog: muiDialog,
    MuiDialogTitle: muiDialogTitle,
    MuiDialogContent: muiDialogContent,
    MuiDialogActions: muiDialogActions,
    MuiTab: muiTab,
    MuiTabs: muiTabs,
    MuiDateCalendar: muiDateCalendar,
    MuiSwitch: muiSwitch,
    MuiDivider: muiDivider,
    MuiCheckbox: muiCheckbox,
    MuiIconButton: muiIconButton,
    MuiTableRow: muiTableRow,
    MuiTableContainer: muiTableContainer,
    MuiTableCell: muiTableCell,
  },
});
